import * as yup from "yup";

export const providersSchema = yup.object().shape({
  name: yup.string().required("Required"),
  value: yup.string().required("Required"),
});
